import { Component, Input, OnInit, inject } from '@angular/core';

import {AlertService} from 'src/app/services/alert.service';

import {Alert} from 'src/app/model/alert.model';
import {AlertTypeEnum} from 'src/app/model/enums/alert-type.enum';
import {Destroyed} from '../../directives/destroyed.directive';
import {takeUntil} from 'rxjs/operators';
import {Router, RouterLink} from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import {MsalService} from "@azure/msal-angular";


@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    imports: [NgFor, NgIf, RouterLink]
})
export class AlertComponent extends Destroyed implements OnInit {
    private readonly alertService = inject(AlertService);
    private readonly router = inject(Router);
    private readonly msalService = inject(MsalService);

    @Input() id: string;

    alerts: Alert[] = [];

    ngOnInit() {
        this.alertService.onAlert(this.id).pipe(takeUntil(this.destroyed)).subscribe(
            alert => {
                if (!alert.message) {
                    // clear alerts when an empty alert is received
                    this.alerts = [];
                    return;
                }
                // add alert to array
                this.alerts.push(alert);
            });
    }

    removeAlert(alert: Alert) {
        // remove specified alert from array
        this.alerts = this.alerts.filter(x => x !== alert);
    }

    cssClass(alert: Alert): string {
        if (!alert) {
            return '';
        }

        // return css class based on alert type
        switch (alert.type) {
            case AlertTypeEnum.SUCCESS:
                return 'alert alert-success';
            case AlertTypeEnum.ERROR:
                return 'alert alert-danger';
            case AlertTypeEnum.INFO:
                return 'alert alert-info';
            case AlertTypeEnum.WARNING:
                return 'alert alert-warning';
            default:
                return '';
        }
    }

  goToLogin() {
    this.msalService.logout();
    this.router.navigate(['/login']).then();
  }
}

